'use strict';

module.exports = require('react/lib/ReactDOM');



/** WEBPACK FOOTER **
 ** node_modules/react-dom/index.js
 **/